import React, { useState } from "react";
import PropTypes from "prop-types";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "./TextField.css";

function TextField({
  label,
  name,
  type,
  setValue,
  isRequired,
  value,
  placeHolder,
  disabled,
  className,
  maxLength,
  regex,
  autoComplete,
  min,
  max,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const controlledValue = value == null ? "" : value;
  const onChange = (e) => {
    if (regex !== "") {
      if (e.target.value === "" || regex.test(e.target.value)) {
        setValue(e.target.value);
      }
    } else {
      setValue(e.target.value);
    }
  };
  return (
    <div className={`text-field-container ${className}`.trim()}>
      <label className="text-field-label">
        {label} {isRequired && "*"}
      </label>
      {type === "multilined" ? (
        <textarea
          className={"text-field-input"}
          name={name}
          required={isRequired}
          value={controlledValue}
          onChange={onChange}
          placeholder={placeHolder}
          disabled={disabled}
          {...(typeof maxLength === "number" && maxLength >= 0
            ? { maxLength }
            : {})}
        />
      ) : type === "password" ? (
        <div className="text-field-password-wrap">
          <input
            className="text-field-input text-field-input--password"
            type={showPassword ? "text" : "password"}
            name={name}
            required={isRequired}
            value={controlledValue}
            onChange={onChange}
            placeholder={placeHolder}
            disabled={disabled}
            autoComplete={autoComplete ?? "current-password"}
            {...(typeof maxLength === "number" && maxLength >= 0
              ? { maxLength }
              : {})}
          />
          <button
            type="button"
            className="text-field-password-toggle"
            onClick={() => setShowPassword((v) => !v)}
            disabled={disabled}
            aria-label={showPassword ? "Hide password" : "Show password"}
            aria-pressed={showPassword}
          >
            {showPassword ? (
              <VisibilityOff sx={{ fontSize: 22 }} />
            ) : (
              <Visibility sx={{ fontSize: 22 }} />
            )}
          </button>
        </div>
      ) : (
        <input
          className={"text-field-input"}
          type={type}
          name={name}
          required={isRequired}
          value={controlledValue}
          onChange={onChange}
          placeholder={placeHolder}
          disabled={disabled}
          min={min ?? undefined}
          max={max ?? undefined}
          {...(autoComplete !== undefined && autoComplete !== ""
            ? { autoComplete }
            : {})}
          {...(typeof maxLength === "number" && maxLength >= 0
            ? { maxLength }
            : {})}
        />
      )}
    </div>
  );
}

TextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeHolder: PropTypes.string,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  regex: PropTypes.string,
  autoComplete: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
};

TextField.defaultProps = {
  label: "",
  name: "",
  type: "text",
  placeHolder: "",
  setValue: () => {},
  isRequired: false,
  value: "",
  disabled: false,
  className: "",
  regex: "",
  min: undefined,
  max: undefined,
};
export default TextField;
